var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reMain" }, [
    _c("div", { staticClass: "reMainContent" }, [
      _c("div", { staticClass: "reNewsContent" }, [
        _c("div", { staticClass: "matchTitle" }, [_vm._v("学校教师注册")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "newsList" },
          [
            _c(
              "el-form",
              {
                ref: "regForm",
                staticClass: "registerForm",
                attrs: {
                  model: _vm.form,
                  rules: _vm.regRules,
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "电子邮箱：", prop: "mail" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入电子邮箱" },
                      model: {
                        value: _vm.form.mail,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "mail", $$v)
                        },
                        expression: "form.mail",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "真实姓名：", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入真实姓名" },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "身份证号码：", prop: "idCard" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入身份证号码" },
                      model: {
                        value: _vm.form.idCard,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "idCard", $$v)
                        },
                        expression: "form.idCard",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "职称：", prop: "title" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入职称" },
                      model: {
                        value: _vm.form.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "title", $$v)
                        },
                        expression: "form.title",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "职务：", prop: "job" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入职务" },
                      model: {
                        value: _vm.form.job,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "job", $$v)
                        },
                        expression: "form.job",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                0
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "QQ号码：", prop: "qq" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入QQ号码" },
                          model: {
                            value: _vm.form.qq,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "qq", $$v)
                            },
                            expression: "form.qq",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "高校名称：", prop: "schoolId" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请选择高校名称",
                          filterable: "",
                        },
                        model: {
                          value: _vm.form.schoolId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "schoolId", $$v)
                          },
                          expression: "form.schoolId",
                        },
                      },
                      [
                        _vm._l(_vm.schoolList, function (i, j) {
                          return [
                            _c(
                              "el-option",
                              {
                                key: j,
                                attrs: { label: i.name, value: i.id },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.onchange(i)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(i.name))]
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                0
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "民族：", prop: "nation" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入民族" },
                          model: {
                            value: _vm.form.nation,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "nation", $$v)
                            },
                            expression: "form.nation",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "手机号码：", prop: "phone" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入手机号码" },
                      model: {
                        value: _vm.form.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "phone", $$v)
                        },
                        expression: "form.phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "descInfo" }, [
                  _vm._v(
                    "\n                        *登录账号为：手机号码，密码默认为：zhjy123!@#\n                    "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btnMode" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.onSubmit("regForm")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            提交注册信息\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }